class CartItem extends HTMLElement {
  constructor() {
    super();
    this.handleItemUpdateDecrease = this.handleItemUpdateDecrease.bind(this);
    this.handleItemUpdateIncrease = this.handleItemUpdateIncrease.bind(this);
    this.handleItemUpdateRemove = this.handleItemUpdateRemove.bind(this);
  }
  connectedCallback() {
    this.handleInitialization();
  }
  disconnectedCallback() {
    this.cleanupEventListeners();
    this.destroyInstance();
  }
  handleInitialization() {
    this.cleanupEventListeners();
    this.cacheDomElements();
    this.setEventListeners();
  }
  cacheDomElements() {
    this.quantityDecreaseButton = this.querySelector(
      '[js-cart-item="decrease"]'
    );
    this.quantityIncreaseButton = this.querySelector(
      '[js-cart-item="increase"]'
    );
    this.quantityInput = this.querySelector(
      '[js-cart-item="quantityInput"]'
    );
    this.removeButton = this.querySelector(
      '[js-cart-item="remove"]'
    );
    this.errorMessage = this.querySelector(
      '[js-cart-item="errorMessage"]'
    );
  }
  setEventListeners() {
    this.cleanupEventListeners();
    if (this.quantityDecreaseButton) {
      this.quantityDecreaseButton.addEventListener(
        "click",
        this.handleItemUpdateDecrease
      );
    }
    if (this.quantityIncreaseButton) {
      this.quantityIncreaseButton.addEventListener(
        "click",
        this.handleItemUpdateIncrease
      );
    }
    if (this.removeButton) {
      this.removeButton.addEventListener("click", this.handleItemUpdateRemove);
    }
  }
  cleanupEventListeners() {
    if (this.quantityDecreaseButton) {
      this.quantityDecreaseButton.removeEventListener(
        "click",
        this.handleItemUpdateDecrease
      );
    }
    if (this.quantityIncreaseButton) {
      this.quantityIncreaseButton.removeEventListener(
        "click",
        this.handleItemUpdateIncrease
      );
    }
    if (this.removeButton) {
      this.removeButton.removeEventListener(
        "click",
        this.handleItemUpdateRemove
      );
    }
  }
  handleItemUpdateDecrease() {
    this.handleItemUpdate("DECREASE");
  }
  handleItemUpdateIncrease() {
    this.handleItemUpdate("INCREASE");
  }
  handleItemUpdateRemove() {
    this.handleItemUpdate("REMOVE");
    const event = new CustomEvent("cart-item:removed");
    document.dispatchEvent(event);
  }
  handleItemUpdate(action) {
    var _a, _b, _c;
    const itemJson = this.getAttribute("item-json");
    const itemData = JSON.parse(itemJson);
    const step = parseInt(((_a = this.quantityInput) == null ? void 0 : _a.getAttribute("step")) || "1");
    const max = parseInt(((_b = this.quantityInput) == null ? void 0 : _b.getAttribute("max")) || "100");
    const min = parseInt(((_c = this.quantityInput) == null ? void 0 : _c.getAttribute("min")) || "1");
    const id = itemData.key;
    let newQuantity = itemData.quantity;
    if (newQuantity >= max && action === "INCREASE") {
      const maxQuantityMessage = window.themeVars.strings.product.maxQuantityReached;
      if (this.errorMessage && this.errorMessage.classList.contains("hidden")) {
        this.errorMessage.innerHTML = `${maxQuantityMessage} ${itemData.title}`;
        this.errorMessage.classList.remove("hidden");
        setTimeout(() => {
          var _a2;
          (_a2 = this.errorMessage) == null ? void 0 : _a2.classList.add("hidden");
        }, 3e3);
      }
      return;
    }
    if (newQuantity <= min && action === "DECREASE") {
      return;
    }
    switch (action) {
      case "DECREASE":
        newQuantity -= step;
        break;
      case "INCREASE":
        newQuantity += step;
        break;
      case "REMOVE":
        newQuantity = 0;
        break;
    }
    const mainCart = this.closest("uwp-main-cart");
    if (!mainCart) {
      console.error("Cart: Cart section not found.");
      return;
    }
    mainCart.changeCartItemQuantity(id, newQuantity);
    mainCart.handleUpdateCartSection();
  }
  destroyInstance() {
    this.quantityDecreaseButton = void 0;
    this.quantityIncreaseButton = void 0;
    this.removeButton = void 0;
  }
}
customElements.define("uwp-cart-item", CartItem);
